import { Component, OnInit } from '@angular/core';
import { GamesGroupService, IPollQuestion } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-polls-page',
  templateUrl: './polls-page.component.html',
  styleUrls: ['./polls-page.component.scss'],
})
export class PollsPageComponent implements OnInit {
  pollsQuestion$: Observable<IPollQuestion[]>;

  constructor(private gamesGroupService: GamesGroupService) {}

  ngOnInit() {
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
  }
}
